const server = {
  uri: (window.location.hostname === 'localhost' ? 'http://itac.localhost' : '')+'/j/',
  params: {
    // headers: new Headers({
    //   "Access-Control-Allow-Origin": "*",
    //   "Access-Control-Allow-Headers": "*",
    // })
  }
};
export default server;